module.exports = __webpack_public_path__ + "img/iq.25630bd4.svg";